import {
  Checkbox,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { memo, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import {
  getAllStorage,
  getData,
  storeData,
  callChoice,
  checkGtokenAccount,
} from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import clsx from "clsx";
import GlobalApi from "../../utils/GlobalApi";
import Loading from "../../components/loading/loading";
import ButtonConcent from "../../components/BoxRightContent/ButtonConcent";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import Configs from "../../constants/Configs";
import qs from "qs";
import { isEmpty } from "lodash";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import { Idc } from "../../utils/GlobalKey";

const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
});

const DigitalConsent = (props) => {
  const classes = useStyle();
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isRead, setIsRead] = useState(false);
  const [checked, setChecked] = useState(false);
  const [callFinished, setCallFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModel, setIsModel] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [dataProduct, setDataProduct] = useState([]);
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [consent, setConsent] = useState({
    checkboxText: "",
    termConText: "",
    titleText: "",
    btnOk: "",
    btnCancel: "",
  });
  const [isModelFailed, setIsModelFailed] = useState(false);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const token = getData("HeaderManp") ? getData("HeaderManp")?.token : "";
  const [isForeignRequest, setIsForeignRequest] = useState(false);
  const [isIsalam, setIsalam] = useState(false);
  const [isIslamModel, setIsIslamModel] = useState(false);

  const header = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
  };
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");
  const productConsent = getData("prodConsent");
  const pass_dipchip = getData("pass_dipchip");
  const pass_ThaID = getData("pass_ThaID");

  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageBookBank = getData("uploadImageBookBank");
  const [textFinished, setTextFinished] = useState({
    title: "",
    message: "",
    btn: "",
  });
  const REDIRECT_URL = "https://www.daolsecurities.co.th";
  const STORAGE_KEY = "open_complete";
  const REDIRECTED_KEY = "has_redirected";

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      (isEmpty(uploadImageBookBank) && ats.f7_isother === "1") ||
      // (pageAgree.ndid !== 1 && !pass_dipchip && !pass_ThaID) ||
      !productConsent
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const getValidateFIFConsent = async () => {
    try {
      setIsLoading(true);
      const token = getData("HeaderManp")
        ? getData("HeaderManp")?.head_token
        : "";
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      let isForeignForAccept = false;
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/product/selbyhead`,
        { head_token: token },
        header,
      )
        .then((res) => {
          if (
            res &&
            res.status === API_CODE_SUCCESS &&
            res.data &&
            res.data.Data
          ) {
            res.data.Data.forEach((section) => {
              section.items.forEach((item) => {
                if (item.investment_id === 5 && item.selected === 1) {
                  isForeignForAccept = true;
                }
              });
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });

      const idCard = getData(Idc) ? getData(Idc).idCard : "";
      if (isForeignForAccept && idCard) {
        await GlobalApi.post(
          `${Configs.baseAPIURL03}/form/consent/selbyhead`,
          {
            head_token: head_token,
            card_id: idCard,
          },
          header,
        )
          .then((res) => {
            if (
              res &&
              res.status === API_CODE_SUCCESS &&
              res.data &&
              res.data.Data &&
              res.data.Data[0]
            ) {
              let isSuccess = res.data.Data[0].IsSuccess;
              if (Number(isSuccess) === 1) {
                isForeignForAccept = false;
              }
            }
            setIsLoading(false);
          })
          .catch((err) => {
            // console.log(err);
            setIsLoading(false);
          });
      }

      setIsForeignRequest(isForeignForAccept);
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
    }
  };

  const getValidateIsalam = async () => {
    // setIsLoading(true);
    try {
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/product_inspec/selbyhead`,
        {
          head_token: head_token,
          id_card: idc?.idCard,
        },
        header,
      )
        .then((res) => {
          if (res && res?.data?.Data?.[0]) {
            if (res?.data?.Data?.[0].IslamicFlag === 1) {
              setIsalam(true);
            }
          }
        })
        .catch((er) => {
          console.log(er);
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };

  const oninitData = async () => {
    const oldCheck = getData("page_agree");
    if (oldCheck?.tcconfirm === 1) {
      setChecked(true);
      setIsRead(true);
    }
  };
  const callGetConsent = async () => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await GlobalApi.get(
        Configs.baseURL + "/api/consent?id=daol_tc_g_token",
        header,
      )
        .then((res) => {
          setIsLoading(false);
          res?.data?.data.forEach((row) => {
            setConsent({
              checkboxText: row?.checkBox,
              termConText: row?.detail,
              titleText: row?.title,
              btnOk: row?.okBtn,
              btnCancel: row?.cancelBtn ? row?.cancelBtn : "",
            });
          });
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  const handleNext = async () => {
    callPostTNC(1);
  };

  const checkFIFConsentBeforeFinish = async () => {
    let isValid = true;
    const findGTokenSelected = dataProduct.some((group) =>
      group.items?.some(
        (product) => product.id === 59 && product.selected === 1,
      ),
    );
    if (findGTokenSelected) {
      const res = await checkGtokenAccount(idc?.idCard, checkuserinfo?.aeCode);
      if (!res) {
        let mss =
          "เนื่องจากท่านเคยเปิดบัญชีหรืออยู่ระหว่างดำเนินการเปิดบัญชี G-Token <br>กรุณาตรวจสอบผลิตภัณฑ์ก่อนเปิดบัญชี <br><br>หากมีข้อสงสัยสามารถติดต่อ DAOL Contact Center 0 2351 1800 เพื่อสอบถามข้อมูลเพิ่มเติม";
        setIsModelFailed(true);
        setTextFinished({
          title: "ขออภัยท่านไม่สามารถเปิดบัญชี G-Token ได้",
          message: mss,
          btn: "ย้อนกลับ",
        });
        setIsModel(true);
        isValid = false;
      }
      setIsLoading(false);
    }
    if (isValid) {
      if (isIsalam) {
        setIsIslamModel(true);
      } else if (isForeignRequest) {
        props.history.push("/fif_consent");
      } else {
        callFinish();
      }
    }
  };

  const handleRedirectToNextPage = async (isClickOkButton) => {
    let checkUpdate = await callPostStatus(isClickOkButton);
    if (checkUpdate) {
      if (isClickOkButton) {
        props.history.push("/islam_condition");
      } else {
        if (isForeignRequest) {
          props.history.push("/fif_consent");
        } else {
          callFinish();
        }
      }
    }
  };

  const callPostStatus = async (confirm) => {
    let statusUpdate = false;
    try {
      setIsLoading(true);
      const body = {
        head_token: head_token,
        product_id: null, // filx
        comfrimation: confirm ? 1 : 0,
        code: "ISLAM",
      };

      await GlobalApi.post(`${Configs.baseAPIURL03}/form/signed_tnc/manp`, body)
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
            statusUpdate = true;
          }
        })
        .catch((er) => {
          setIsLoading(false);
          const api_error = getData("api_error")?.data;
          if (api_error.MsgDesc && api_error.MsgDesc?.message) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error.MsgDesc?.message);
          } else if (api_error?.MsgDesc) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error?.MsgDesc);
          } else {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(
              "สอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ DAOL Contact Center<br>0 2351 1800",
            );
          }
          setIsModalError(true);
        });
    } catch (error) {
      setIsLoading(false);
      const api_error = getData("api_error")?.data;
      setModalErrorTitle("เกิดข้อผิดพลาด");
      setModalErrorDes("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง");
      setIsModalError(true);
    }
    return statusUpdate;
  };

  const callFinish = async () => {
    const atsDataUser = getData("atsDataUser") || {};
    const { bankCode } = atsDataUser;
    const f7_ats = getData("f7_ats") || {};
    const { f7_isother } = f7_ats;
    setIsLoading(true);
    setCallFinished(true);

    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/finished`,
        {
          head_token: head_token,
          comfrimation: 1,
          use_other_bank: parseInt(f7_isother),
        },
        { headers: { "content-type": "application/json" } },
      );
      if (!res.data) {
        setCallFinished(false);
        setIsModelFailed(true);
        setTextFinished({
          title: translations?.[lang]?.textFinishFailed?.title,
          message: translations?.[lang]?.textFinishFailed?.message,
          btn: translations?.[lang]?.textFinishFailed?.btn,
        });
        setIsModel(true);
        setIsLoading(false);
        return;
      }
      // ✅ เรียก 2 ฟังก์ชันหลักและรอให้สำเร็จ
      await saveComeback();
      await deleteCase();
    } catch (error) {
      console.error("เกิดข้อผิดพลาดใน callFinish:", error);
      setIsModelFailed(true);
      setTextFinished({
        title: translations?.[lang]?.textFinishFailed?.title,
        message: "ไม่สามารถทำรายการได้ กรุณาลองใหม่อีกครั้ง",
        btn: translations?.[lang]?.textFinishFailed?.btn,
      });
      setIsModel(true);
    }
  };

  const saveComeback = async () => {
    storeData("stamp_page", "FINISH");
    const last_stamp = JSON.stringify(await getAllStorage("FINISH"));

    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "FINISH",
        },
      },
    ];

    try {
      const response = await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        header,
      );

      setIsLoading(false);

      const isSuccess = response?.data?.Data?.[0]?.[0]?.IsSuccess === 1;

      if (!isSuccess) {
        const msgDesc = response?.data?.Data?.[0]?.MsgDesc || "";
        const message =
          msgDesc !== ""
            ? msgDesc
            : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";

        setIsModelFailed(true);
        setTextFinished({
          title: translations?.[lang]?.textFinishFailed?.title,
          message: translations?.[lang]?.textFinishFailed?.message,
          btn: translations?.[lang]?.textFinishFailed?.btn,
        });
        setIsModel(true);
        return;
      }

      const hasRiskGroup =
        getData("riskGroupCurrent") ||
        getData("riskGroupIdc") ||
        getData("riskGroupWorkPlace") ||
        getData("riskGroupCareer") ||
        getData("riskGroupBusiness");

      setTextFinished(
        hasRiskGroup
          ? {
              title: translations?.[lang]?.textFinishRisk3?.title,
              message: translations?.[lang]?.textFinishRisk3?.message,
              btn: translations?.[lang]?.textFinishRisk3?.btn,
            }
          : {
              title: translations?.[lang]?.textFinished?.title,
              message: translations?.[lang]?.textFinished?.message,
              btn: translations?.[lang]?.textFinished?.btn,
            },
      );
      // ✅ สำเร็จ: ล้างรูปภาพ
      await clearImage();
      window.localStorage.clear(); // clear หลังอ่านแล้ว
      setIsModel(true);
    } catch (error) {
      setIsLoading(false);

      const apiError = getData("api_error")?.message || "ไม่ทราบสาเหตุ";
      const errorMessage =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + apiError + ")";

      setIsModelFailed(true);
      setTextFinished({
        title: translations?.[lang]?.textFinishFailed?.title,
        message: errorMessage,
        btn: translations?.[lang]?.textFinishFailed?.btn,
      });
      setIsModel(true);
    }
  };

  const deleteCase = async () => {
    const saveData = {
      url: `${Configs.baseURL}/case/delete`,
      postData: {
        safh_id: token,
      },
    };
    try {
      const response = await GlobalApi.delete(saveData.url, saveData.postData);
    } catch (error) {
      setIsLoading(false);
      const apiError = getData("api_error")?.message || "ไม่ทราบสาเหตุ";
      const errorMessage =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + apiError + ")";
      setIsModelFailed(true);
      setTextFinished({
        title: translations?.[lang]?.textFinishFailed?.title,
        message: errorMessage,
        btn: translations?.[lang]?.textFinishFailed?.btn,
      });
      setIsModel(true);
    }
  };

  const onConfirm = (read) => {
    setIsRead(read);
  };

  useEffect(() => {
    // ถ้ากด back กลับมา → ไป index
    const hasRedirected = localStorage.getItem(REDIRECTED_KEY);
    if (hasRedirected) {
      localStorage.removeItem(REDIRECTED_KEY);
      props.history.replace("/");
      return;
    }

    // tab อื่น redirect ตาม
    const handleStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          if (data.type === "REDIRECT") {
            localStorage.setItem(REDIRECTED_KEY, "true");
            window.location.replace(data.url);
          }
        } catch (err) {}
      }
    };

    // bfcache (Safari)
    const handlePageShow = (e) => {
      if (e.persisted && localStorage.getItem(REDIRECTED_KEY)) {
        localStorage.removeItem(REDIRECTED_KEY);
        props.history.replace("/");
      }
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const popUps = () => {
    localStorage.setItem(REDIRECTED_KEY, "true");
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ type: "REDIRECT", url: REDIRECT_URL, t: Date.now() }),
    );
    window.location.replace(REDIRECT_URL);
  };
  const popUpsFailed = (e) => {
    props.history.push("/products_choice");
  };

  const callPostTNC = async (confirm) => {
    try {
      setIsLoading(true);
      const body = {
        head_token: head_token,
        product_id: null,
        comfrimation: confirm,
        code: "AGBR",
      };
      await GlobalApi.post(`${Configs.baseAPIURL03}/form/signed_tnc/manp`, body)
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
            // callFinish();
            checkFIFConsentBeforeFinish();
          }
        })
        .catch((er) => {
          setIsLoading(false);
          const api_error = getData("api_error")?.data;
          if (api_error.MsgDesc && api_error.MsgDesc?.message) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error.MsgDesc?.message);
          } else if (api_error?.MsgDesc) {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(api_error?.MsgDesc);
          } else {
            setModalErrorTitle("เกิดข้อผิดพลาด");
            setModalErrorDes(
              "สอบถามข้อมูลเพิ่มเติมกรุณาติดต่อ DAOL Contact Center<br>0 2351 1800",
            );
          }
          setIsModalError(true);
        });
    } catch (error) {
      setIsLoading(false);
      const api_error = getData("api_error")?.data;
      setModalErrorTitle("เกิดข้อผิดพลาด");
      setModalErrorDes("ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง");
      setIsModalError(true);
    }
  };
  const clickBack = () => {
    const tcconfirm = getData("tcconfirm");
    if (tcconfirm?.confirm === 1) {
      props.history.push("/summary");
    } else {
      props.history.push("/products_consent");
    }
  };
  const clearImage = async () => {
    try {
      var postData = {
        head_token,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/clearupload`,
        qs.stringify(postData),
        header,
      )
        .then(async (res) => {
          setIsLoading(false);
          // console.log(res);
        })
        .catch((er) => {
          // console.log(er);
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
        getData("api_error")?.message +
        ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
    }
    return;
  };
  const getProductChoice = async () => {
    try {
      setIsLoading(true);
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/product/selbyhead`,
        { head_token: head_token },
        header,
      )
        .then((res) => {
          if (res.status === API_CODE_SUCCESS) {
            setDataProduct(res?.data?.Data);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          // console.log(err);
          setIsLoading(false);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(async () => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        oninitData();
      }
    });
    await callGetConsent();
    await getValidateFIFConsent();
    await getValidateIsalam();
  }, []);
  useEffect(() => {
    getProductChoice();
    // cellCurrency();
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <DialogCustoms
            open={isIslamModel}
            isModel={setIsIslamModel}
            imgModalError
            title={"ท่านอยู่ในการดูแลของทีม DAOL-Islamic (PW3)"}
            massage={
              "เพื่อให้เป็นไปตามหลักศาสนาอิสลาม\nท่านประสงค์ไม่รับดอกเบี้ยที่เกิดจาก\nการฝากเงินหลักประกันในบัญชีซื้อขาย\nหลักทรัพย์และอนุพันธ์ใช่หรือไม่ ? \n(หากท่านนับถือศาสนาอิสลามกด “ใช่”หากท่านไม่ได้นับถือศาสนาอิสลามกด “ไม่”)"
            }
            idBtnPrimary="continue"
            idBtnSecondary="retry"
            btnPrimary={"ใช่"}
            btnSecondary={"ไม่"}
            switchType={(e) => handleRedirectToNextPage(e)}
          />
          <HeaderPage
            title={translations?.[lang]?.tcconfirm?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.tcconfirm}
                        clickBack={(e) => clickBack()}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <HeaderRight
                          title={translations?.[lang]?.tcconfirm?.title}
                        />
                        <Grid className="box-right-content">
                          <PanelScrollBar
                            content={
                              <Grid container>
                                <Grid className="sub-title">
                                  <Typography
                                    className="box-title text-left font-20 pt-2"
                                    dangerouslySetInnerHTML={{
                                      __html: consent.titleText,
                                    }}
                                  ></Typography>
                                </Grid>
                                <Grid className={classes.content}>
                                  <Grid
                                    className={clsx(classes.font, "font-20")}
                                    dangerouslySetInnerHTML={{
                                      __html: consent.termConText,
                                    }}
                                  ></Grid>
                                </Grid>
                              </Grid>
                            }
                            confirmRead={onConfirm}
                          />
                          {/* check box content */}
                          <Grid>
                            <Grid className="checkbox-consent">
                              <Checkbox
                                className="check-box-deco"
                                sx={{
                                  color: "#023b66",
                                  opacity: "0.8",
                                  "&.Mui-checked": {
                                    color: "#023b66",
                                    opacity: "0.8",
                                  },
                                }}
                                disabled={!isRead}
                                checked={checked}
                                onChange={handleCheck}
                              />
                              <Grid
                                onClick={(e) => {
                                  if (isRead) {
                                    setChecked(!checked);
                                  } else {
                                    setChecked(false);
                                  }
                                }}
                                className={clsx(
                                  classes.content,
                                  isMobile
                                    ? "content-check-box-mb"
                                    : "content-check-box",
                                  "text-left font-18 product-choice-p",
                                  !isRead ? "checkbox-unread" : "checkbox-read",
                                )}
                                dangerouslySetInnerHTML={{
                                  __html: consent.checkboxText,
                                }}
                              ></Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* button */}
                        <ButtonConcent
                          tcconfirm
                          textOk={consent?.btnOk}
                          textCancel={consent?.btnCancel}
                          isDisbled={!checked || callFinished}
                          onNextPage={handleNext}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <DialogCustoms
              imgModalFinished
              open={isModel}
              isModel={setIsModel}
              switchType={(e) => {
                if (isModelFailed) {
                  setIsModelFailed(false);
                  setIsModel(false);
                  popUpsFailed(e);
                } else {
                  popUps(e);
                }
              }}
              title={textFinished?.title}
              massage={textFinished?.message}
              btnPrimary={textFinished?.btn}
            />
            <DialogCustoms
              imgModalError
              open={isModalError}
              isModel={modalErrorTitle}
              switchType={(e) => setIsModalError(false)}
              title={modalErrorTitle}
              massage={modalErrorDes}
              btnPrimary={"ยอมรับ"}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(DigitalConsent);
